"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextBody = void 0;
var _createText = require("./createText");
const TextBody = (0, _createText.createText)('body');
exports.TextBody = TextBody;